import React, { memo, useMemo } from "react"
import { AspectRatio, Box, Image } from "@chakra-ui/react"
import { Swiper, SwiperSlide } from "swiper/react"
import SwiperCore, { Pagination } from "swiper"
import "swiper/css"

import type { ProductCombinedProps } from "@root/types/global"
import { useImage } from "@app/hooks/useImage"

type Props = {
  product: ProductCombinedProps
}

// eslint-disable-next-line react-hooks/rules-of-hooks
SwiperCore.use([Pagination])

export const ProductMediaSwiperMobile: React.FC<Props> = memo(({ product }) => {
  const { sortGenderImages } = useImage()

  const images = useMemo(() => product?.images.sort(sortGenderImages) || [], [product, sortGenderImages])

  return images.length > 0 ? (
    <AspectRatio bg="grey.cloud" ratio={375 / 527} w="full">
      <Box
        sx={{
          ".swiper-pagination-horizontal": { w: "fit-content", left: 6, bottom: 0 },
          ".swiper-horizontal": { w: "full" },
        }}
      >
        <Swiper
          cssMode
          pagination={{ clickable: true, el: `#product-${product?.handle}-pagination`, type: "bullets" }}
          slidesPerView={1}
          spaceBetween={0}
        >
          {images.map((image, index) => (
            <SwiperSlide key={index}>
              <Box>
                <Image {...image} w="full" />
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
        <Box
          pos="absolute"
          insetX={0}
          id={`product-${product?.handle}-pagination`}
          sx={{
            ".swiper-pagination-bullet-active": {
              background: "#767676 !important",
            },
            ".swiper-pagination-bullet": {
              w: 3,
              h: 3,
              opacity: 1,
              background: "grey.cloud",
            },
          }}
        />
      </Box>
    </AspectRatio>
  ) : (
    <AspectRatio bg="grey.cloud" ratio={375 / 527} w="full">
      <Box />
    </AspectRatio>
  )
})
